import MyTasksWrapper from './MyTasksWrapper';

export default MyTasksWrapper;
